import { Tooltip } from "antd";
import React from "react";
import "./index.scss";

export const WithRoleLinkToolTip = ({ children, accessTypeLink, column, dataTestId, getPopupContainer }) => {
  if (column.identifier === "Role") {
    return (
      <Tooltip
        className={"review-role-popover"}
        title={
          <div className={"review-role-popover-text"} data-testid={dataTestId}>
            Need more information on the <b>{column.title}</b>, click{" "}
            <a href={accessTypeLink} target="#">
              here
            </a>
          </div>
        }
        getPopupContainer={getPopupContainer ?? (() => document.body)}
      >
        <div className="review-role-container">{children}</div>
      </Tooltip>
    );
  }
  return children;
};